import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { RoutingService } from "@skylab-angular-shared/core";
import { Module, withModule, withPermission } from "@skylab-shared/business";
import { UserPermissionKind } from "@skylab-shared/dataModel";
import { AppStates } from "@skylab-shared/scenes";

export const canActivateAvailability = (modules: Module[] = [], permissions: UserPermissionKind[] = []): CanActivateFn => {
	return () => {
		const routingService = inject(RoutingService);
		if ((modules.length && !withModule(modules))) {
			routingService.navigate([AppStates.pageUnavailable.url], {queryParams: {module: modules[0] }});
			return false;
		} else if (permissions.length && !withPermission(permissions)) {
			routingService.navigate([AppStates.pageUnavailable.url], {queryParams: {permission: permissions[0]}});
			return false;
		}
		return true;
	};
};
